import { createSlice } from "@reduxjs/toolkit";

export const sessionUserAttributesSlice = createSlice({
  name: "sessionUserAttributes",
  initialState: {
    value: {},
  },
  reducers: {
    setSessionUserAttributes: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setSessionUserAttributes } = sessionUserAttributesSlice.actions;

export default sessionUserAttributesSlice.reducer;
